import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = ["src"]

import { ref, computed, onMounted, watch } from 'vue'
    import { useRouter } from 'vue-router'
    import { useOrganizationUnitId } from '@common/composables'
    import { useManageBrandingPage } from '@Organizations/OrganizationUnits/pages-core'
    import FileUploader from '@Blobs/Components/FileUploader.vue'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import axios from 'axios'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ManageBrandingPage',
  setup(__props) {

    const tid = useOrganizationUnitId()
    const logoFile = ref<File | null>(null)
    const logoBlobId = ref<string | null>(null)

    const {
        useBrandingQuery,
        useApplyBrandingCommand,
        useResetBrandingCommand
    } = useManageBrandingPage()

    const { modelBrandingQueryV1, runBrandingQueryV1 } = useBrandingQuery(tid)

    const organizationId = computed(() => modelBrandingQueryV1.value?.Id)
    const logoUrl = computed(() => logoFile.value ? URL.createObjectURL(logoFile.value) : modelBrandingQueryV1.value?.LogoUrl)

    const { invokeApplyBrandingCommandV1 } = useApplyBrandingCommand(organizationId, logoBlobId)
    const { invokeResetBrandingCommandV1 } = useResetBrandingCommand(organizationId)

    onMounted(() => {
        document.title = 'Manage branding'
        runBrandingQueryV1()
    })

    watch(modelBrandingQueryV1, () => logoBlobId.value = modelBrandingQueryV1.value?.LogoBlobId)

    function handleLogoUploaded(blobId: string) {
        logoBlobId.value = blobId
        invokeApplyBrandingCommandV1()        
    }

    async function handleRemoveLogo() {
        if (confirm('Do you really want to remove logo?')) {
            try {
                await axios.delete('/blobs/v2/delete/' + (logoBlobId.value || ''))
            } finally {
                invokeResetBrandingCommandV1()
                runBrandingQueryV1()
                logoFile.value = null
            }
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;\">Manage company branding</h1></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 30px;\">", 2)),
    (organizationId.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (logoUrl.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: logoUrl.value,
                style: {"max-width":"200px"}
              }, null, 8 /* PROPS */, _hoisted_3))
            : _createCommentVNode("v-if", true),
          _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createVNode(FileUploader, {
            ttl: null,
            skipConfirmation: false,
            hideProgress: true,
            onSelected: _cache[0] || (_cache[0] = ($event: any) => (logoFile.value=$event)),
            onUploaded: handleLogoUploaded,
            accept: "image/png,image/gif,image/jpeg,image/svg+xml"
          }, {
            file: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("   ", -1 /* CACHED */)
            ]))]),
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary"
              }, "Change logo", -1 /* CACHED */))
            ]),
            _: 1 /* STABLE */
          }),
          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          (logoBlobId.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: handleRemoveLogo,
                type: "button",
                class: "btn btn-secondary"
              }, "Remove logo"))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})